import { useInput, useTranslate } from "ra-core";

import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";

interface CheckboxGroupInputProps {
  source: string;
  label: string;
  choices: { id: string; name: string }[];
}

// Several values from a fixed list, as large checkboxes that work with one
// tap on a phone (the roles of a person, task 1.5).
export const CheckboxGroupInput = ({
  source,
  label,
  choices,
}: CheckboxGroupInputProps) => {
  const translate = useTranslate();
  const { field } = useInput({ source, defaultValue: [] });
  const selected = (field.value as string[] | undefined) ?? [];

  const toggle = (id: string, isChecked: boolean) =>
    field.onChange(
      isChecked
        ? [...selected.filter((value) => value !== id), id]
        : selected.filter((value) => value !== id),
    );

  return (
    <fieldset className="flex flex-col gap-2">
      <legend className="mb-1 text-sm font-medium">{translate(label)}</legend>
      <div className="grid grid-cols-2 gap-2 md:grid-cols-4">
        {choices.map((choice) => {
          const id = `${source}-${choice.id}`;
          return (
            <div key={choice.id} className="flex min-h-10 items-center gap-2">
              <Checkbox
                id={id}
                className="size-5"
                checked={selected.includes(choice.id)}
                onCheckedChange={(checked) =>
                  toggle(choice.id, checked === true)
                }
              />
              <Label htmlFor={id}>{translate(choice.name)}</Label>
            </div>
          );
        })}
      </div>
    </fieldset>
  );
};
